import { FilterParamsType } from '@/api/helpers/apiParamsHelpers';
import { ApiParams } from '@/api/helpers/apiHelpers';
import { getInternalOrganizationBillingEventsApi } from '@/api/v1/organization/internal/getInternalOrganizationBillingEventsApi';
import { getInternalOrganizationBillingReportApi } from '@/api/v1/organization/internal/getInternalOrganizationBillingReportApi';
import { prepareBillingSearchFiltersListApiParams } from '@/bundle/_Opco/_BilledEventsPage/helpers/helpers';
import { prepareResponse, throwResponseError } from '@/helpers/apiHelpers/responseHelpers';

export const getInternalOrganizationBillingEvents = async (params: ApiParams) => {
  const apiParams = prepareBillingSearchFiltersListApiParams(params);

  try {
    const response = await getInternalOrganizationBillingEventsApi(apiParams);

    return prepareResponse(response);
  } catch (e) {
    throwResponseError(e);
  }
};

export const getInternalOrganizationBillingReport = async (filters: FilterParamsType) => {
  try {
    const response = await getInternalOrganizationBillingReportApi(filters);

    return prepareResponse(response, ['Content-Disposition']);
  } catch (e) {
    throwResponseError(e);
  }
};
